/**
 * Routes
 */

const FallbackRoutes = [

];

export {FallbackRoutes};    